import "./NotFoundPage.style.css";

import { Link } from "react-router-dom";
import { AppRouter } from "../../utils/enums/AppRouter";

import errorImage from "../../resources/images/error.png";

export const NotFoundPage = () => {
  return (
    <div className="not-found-page">
      <div className="not-found-page__content">
        <div className="not-found-page__description">
          <img src={errorImage} alt="Ошибка 404" />
          <span className="header_2">Мы не смогли найти такую страницу :(</span>
        </div>
        <Link className="header_4" to={AppRouter.Main}>
          Вернуться на главную
        </Link>
      </div>
    </div>
  );
};
